import React, { useEffect, useState } from "react";
import { openStatus } from "../data/hours";

export default function OpenNow({ className = "" }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    const tick = () => setS(openStatus());
    tick();
    const t = setInterval(tick, 60000);
    return () => clearInterval(t);
  }, []);
  if (!s) return <span className={`opennow ${className}`}><i /><span>Tue to Sun, 11 to 7</span></span>;
  return (
    <span className={`opennow ${s.open ? "is-open" : ""} ${className}`}>
      <i /><span>{s.label}</span>
      <style dangerouslySetInnerHTML={{ __html: `
        .opennow { display: inline-flex; align-items: center; gap: 10px; font-size: .7rem; letter-spacing: .2em; text-transform: uppercase; font-weight: 500; }
        .opennow i { width: 8px; height: 8px; border-radius: 50%; background: var(--ash); flex: none; }
        .opennow.is-open i { background: var(--moss); box-shadow: 0 0 0 4px rgba(111,123,76,.25); }
      ` }} />
    </span>
  );
}
